export default __webpack_public_path__ + "static/media/icon-like-grey.f7719f84.svg";